import { ReadFile } from '@paragon/client-tools';
import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { closeCurrentPopup } from '@paragon/popup-state';

import { focusCameraOnSelectedObjectOrFallback } from '../../three/ThreeJsSceneActions';
import { getActiveLevelOrNull } from '../selectors/layoutDataSelectors';
import { layoutSlice } from '../slices/layoutSlice';
import { saveEntireLayout } from './editorActions';
import { autoCutPlanes } from './layout/roofPlaneActions';
import { showBearingImageUploadDialog } from './popupActions';
import { selectItems } from './selectActions';
import { AsyncThunkActionVoid } from './thunkActions';

export const extractBearingEnvelopesFromImage =
  (image: ReadFile): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    if (getState().application.openContext?.type !== 'project') return;

    const activeLevel = getActiveLevelOrNull(getState());

    dispatch(showBearingImageUploadDialog(image.contents));

    let roofPlaneGuids: string[];

    try {
      let { bearingEnvelopes, roofPlanes } = await designService.ai.extractBearings(image);

      if (activeLevel != null) {
        bearingEnvelopes = bearingEnvelopes.map((envelope) => ({ ...envelope, levelGuid: activeLevel.guid }));
        roofPlanes = roofPlanes.map((plane) => ({ ...plane, levelGuid: activeLevel.guid }));
      }

      dispatch(layoutSlice.actions.bearingEnvelopesUpserted({ bearingEnvelopes }));

      dispatch(selectItems(bearingEnvelopes, 'wall'));
      focusCameraOnSelectedObjectOrFallback();

      roofPlaneGuids = roofPlanes.map((plane) => plane.guid);
      dispatch(layoutSlice.actions.roofPlanesUpserted(roofPlanes));
    } catch {
      dispatch(enqueueError('Error identifying walls. Please contact Paragon Customer Support.'));
      return;
    } finally {
      dispatch(closeCurrentPopup());
    }

    await dispatch(saveEntireLayout());

    await dispatch(autoCutPlanes(roofPlaneGuids));
    await dispatch(saveEntireLayout());
  };
